import { GetRedDotResponse, PostRedDotReadParams } from './types';
import { apiClient } from '../../axios';

export const getRedDotApi = () => apiClient.get<GetRedDotResponse>('/v1/red-dot');
export const postRedDotReadApi = (data: PostRedDotReadParams) => apiClient.post('/v1/red-dot/read', data);
